// extracted by mini-css-extract-plugin
module.exports = {"container":"PageNotFound_container__XDRhy","info":"PageNotFound_info__2whrb","link":"PageNotFound_link__vc36T"};